import React, { Fragment, useEffect, useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
  Box,
} from '@mui/material';

import UserUsageItem from './UserUsageItem';
import InvoiceShowFormattedMessages from '../../../../messages/billing/InvoiceShowFormattedMessages';
import Loader from '../../../common/Loader';

import { invoiceTable, invoiceTableHeader } from '../../../../styles/tables';

const UserUsage = ({ userUsageData, invoice, billDates, getDataFunction }) => {
  useEffect(() => {
    getDataFunction();
  }, [getDataFunction]);

  const generateTable = () => {
    let content;

    // If do not have user usage data or users list, return message noting this
    if (!userUsageData || userUsageData.length === 0) {
      content = InvoiceShowFormattedMessages.NoDetailsFound;

      // Else if prepaid, return message noting this
    } else if (userUsageData === 'prepaid') {
      content = InvoiceShowFormattedMessages.NoDetailsPrepaid;
    } else {
      let data = [];

      // Iterate over data for each cost centre
      for (let i = 0; i < userUsageData.length; i++) {
        const { users, cost_centre_id, cost_centre_name } = userUsageData[i];
        let userArray = [];

        // Iterate over data for each user in the cost centre
        for (let j = 0; j < users.length; j++) {
          const user = users[j];
          let dateArray = [];

          // Iterate over data for each date entry for the user
          for (let k = 0; k < user.dates.length; k++) {
            let date = user.dates[k];
            dateArray.push(
              <UserUsageItem
                key={k}
                user_name={user.user_name}
                revenue_date={date.revenue_date}
                direct_sent={date.direct_sent}
                messages_sent={date.messages_sent}
                reminders_sent={date.reminders_sent}
                replies_sent={date.replies_sent}
                binary_sent={date.binary_sent}
                total={date.total}
                premium_sent={date.premium_sent}
                costCenter={cost_centre_name}
              />
            );
          }
          userArray.push(<Fragment key={j}>{dateArray}</Fragment>);
        }
        data.push(<Fragment key={cost_centre_id}>{userArray}</Fragment>);
      }
      content = (
        <TableContainer>
          <Table sx={invoiceTable} aria-label="usage table">
            <TableBody>
              <TableRow>
                <TableCell sx={invoiceTableHeader} align="center">
                  <Typography fontWeight={700}>
                    {InvoiceShowFormattedMessages.costCenter}
                  </Typography>
                </TableCell>
                <TableCell sx={invoiceTableHeader} align="center">
                  <Typography fontWeight={700}>
                    {InvoiceShowFormattedMessages.userName}
                  </Typography>
                </TableCell>
                <TableCell sx={invoiceTableHeader} align="center">
                  <Typography fontWeight={700}>
                    {InvoiceShowFormattedMessages.date}
                  </Typography>
                </TableCell>
                <TableCell sx={invoiceTableHeader} align="center">
                  <Typography fontWeight={700}>
                    {InvoiceShowFormattedMessages.direct}
                  </Typography>
                </TableCell>
                <TableCell sx={invoiceTableHeader} align="center">
                  <Typography fontWeight={700}>
                    {InvoiceShowFormattedMessages.standard}
                  </Typography>
                </TableCell>
                <TableCell sx={invoiceTableHeader} align="center">
                  <Typography fontWeight={700}>
                    {InvoiceShowFormattedMessages.reminders}
                  </Typography>
                </TableCell>
                <TableCell sx={invoiceTableHeader} align="center">
                  <Typography fontWeight={700}>
                    {InvoiceShowFormattedMessages.replies}
                  </Typography>
                </TableCell>
                <TableCell sx={invoiceTableHeader} align="center">
                  <Typography fontWeight={700}>
                    {InvoiceShowFormattedMessages.international}
                  </Typography>
                </TableCell>
                <TableCell sx={invoiceTableHeader} align="center">
                  <Typography fontWeight={700}>
                    {InvoiceShowFormattedMessages.others}
                  </Typography>
                </TableCell>
                <TableCell sx={invoiceTableHeader} align="center">
                  <Typography fontWeight={700}>
                    {InvoiceShowFormattedMessages.total}
                  </Typography>
                </TableCell>
              </TableRow>
              {data}
            </TableBody>
          </Table>
        </TableContainer>
      );
    }

    return content;
  };

  const renderContent = () => {
    if (!userUsageData) {
      return <Typography>{InvoiceShowFormattedMessages.loading}</Typography>;
    }

    return (
      <Fragment>
        {!userUsageData ? (
          <Loader />
        ) : (
          <Box>
            <Typography variant="h1" color="common.black">
              {InvoiceShowFormattedMessages.userUsageDetails}
            </Typography>
            <Typography
              component="h2"
              sx={{ color: 'common.black', fontSize: 18 }}
            >
              {`Daily User Usage Breakdown For: ${invoice.customerName}`}
            </Typography>
            <br />
            <Typography fontWeight={700} gutterBottom>
              {`User Usage for period ${billDates.start_date} `}
              {InvoiceShowFormattedMessages.to}
              {` ${billDates.end_date}`}
            </Typography>
            {generateTable()}
          </Box>
        )}
      </Fragment>
    );
  };

  return renderContent();
};

export default UserUsage;
